export default[
 "Mandarin — 中文普通话",
 "Wu Chinese — 中文吴语",
 "Xiang Chinese — 中文湘语",
 "Gan Chinese — 中文赣语",
 "Min Chinese — 中文闽语",
 "Yue Chinese — 中文粤语",
 "Ping Chinese — 中文平语",
 "Huizhou Chinese — 中文徽语",
 "Hakka(Kejia) Chinese — 中文客家语",
 "Sichuanese — 中文四川话",
 "Turkic(Uyghur, Kazakh . . .) — 突厥语系(维吾尔，哈萨克等)",
 "Tibeto-Burman — 藏缅语族",
 "Tai–Kadai — 侗台语系",
 "Mongolic — 蒙古语",
 "Tungusic(Manchu, Xibe, Oroqen . . .) — 通古斯满语系(满洲，锡伯，鄂伦春等)",
 "Other Chinese minority languages — 其他少数民族方言",
 "English(United States) — 英语(美国)",
 "English(Australia) — 英语(澳大利亚)",
 "English(Canada) — 英语(加拿大)",
 "English(India) — 英语(印度)",
 "English(Ireland) — 英语(爱尔兰)",
 "English(New Zealand) — 英语(新西兰)",
 "English(Singapore) — 英语(新加波)",
 "English(South Africa) — 英语(南非)",
 "English(United Kingdom) — 英语(英国)",
 "Arabic(Israel) — 阿拉伯语(以色列)",
 "Arabic(Egypt) — 阿拉伯语(埃及)",
 "Dutch(Netherlands) — 荷兰语",
 "Dutch(Switzerland) — 荷兰语(比利时)",
 "French(France) — 法语",
 "French(Belgium) — 法语(比利时)",
 "French(Canada) — 法语(加拿大)",
 "French(Switzerland) — 法语(瑞士)",
 "German(Germany) — 德语",
 "German(Liechtenstein) — 德语(列支敦斯登)",
 "German(Austria) — 德语(奥地利)",
 "German(Switzerland) — 德语(瑞士)",
 "Italian(Italy) — 意大利语",
 "Italian(Switzerland) — 意大利语(瑞士)",
 "Portuguese(Portugal) — 葡萄牙语(巴西)",
 "Portuguese — 葡萄牙语(巴西)",
 "Spanish(Spain) — 西班牙语",
 "Spanish(United States) — 西班牙语(美国)",
 "Bengali — 孟加拉语",
 "Bengali(India) — 孟加拉语(印度)",
 "hrvatski — 克罗地亚语",
 "Czech — 捷克语",
 "Danish — 丹麦语",
 "Greek — 希腊语 ",
 "Hebrew — 希伯来语",
"Hindi — 印度语",
"Hungarian — 匈牙利语",
"Indonesian — 印度尼西亚语",
"Japanese — 日语",
"Korean — 韩语(朝鲜语)",
"Malay — 马来语",
"Perisan — 波斯语",
"Polish — 波兰语",
"Romanian — 罗马尼亚语",
"Russian — 俄罗斯语",
"Serbian — 塞尔维亚语",
"Swedish — 瑞典语",
"Thai — 泰语",
"Turkey — 土耳其语",
"Urdu — 乌尔都语",
"Vietnamese — 越南语",
"Catalan(Spain) — 加泰隆语(西班牙)",
"Latviesu — 拉脱维亚语",
"Lithuanian — 立陶宛语",
"Norwegian — 挪威语",
"Slovencina — 斯洛伐克语",
"Slovenian — 斯洛文尼亚语",
"Bulgarian — 保加利亚语",
"Ukrainian — 乌克兰语",
"Filipino — 菲律宾语",
"Finnish — 芬兰语",
"Afrikaans — 南非语",
"Romansh(Switzerland) — 罗曼什语(瑞士)",
"Burmese(Zawgyi) — 缅甸语(民间)",
"Burmese(Paduak) — 缅甸语(官方)",
"Khmer — 柬埔寨语",
"Amharic — 阿姆哈拉语(埃塞俄比亚)",
"Belarusian — 白俄罗斯语",
"Estonian — 爱沙尼亚语",
"Swahili — 斯瓦希里语(坦桑尼亚)",
"Zulu — 祖鲁语(南非)",
"Azerbaijani — 阿塞拜疆语",
"Armenian — 亚美尼亚语(亚美尼亚)",
"Georgian — 格鲁吉亚语(格鲁吉亚)",
"Laotian — 老挝语(老挝)",
"Mongolian — 蒙古语",
"Nepali — 尼泊尔语",
"Kazakh — 哈萨克语",
"Galician — 加利西亚语 ",
"Icelandic — 冰岛语 ",
"Kannada — 坎纳达语",
"Kyrgyz — 吉尔吉斯语",
"Malayalam — 马拉亚拉姆语",
"Marathi — 马拉提语/马拉地语",
"Tamil — 泰米尔语",
"Macedonian — 马其顿语",
"Telugu — 泰卢固语",
"Uzbek — 乌兹别克语",
"Basque — 巴斯克语",
"Sinhala — 僧加罗语(斯里兰卡)"
]


// WEBPACK FOOTER //
// ./src/Data/languages.js